import React, { useState, useEffect, useContext } from "react";
import AppContext from "../../context";
import SectionHeader from "../Layout/SectionHeader";
// import ActionLinks from "../Layout/ActionLinks";
import config from "../../helpers/config";
import uploadToSignedUrl from "../../helpers/uploadToSignedUrl";
import btnFB from "../../images/btn-FB.png";
import btnIGS from "../../images/btn-IGS.png";
import btnPrint from "../../images/btn-PRINT.png";
import btnTW from "../../images/btn-TW.png";

const Output = () => {
  const {
    name,
    selectedQuote,
    uuid,
    saved,
    metaNavyImage,
    metaRedImage,
    metaTealImage,
    instaNavyImage,
    instaTealImage,
    instaRedImage,
  } = useContext(AppContext);

  const [metaImage, setMetaImage] = useState();
  const [instaImage, setInstaImage] = useState();
  const [currentTheme, setCurrentTheme] = useState("navy");

  function updateTheme(e) {
    setCurrentTheme(e.target.name);
    if (e.target.name === "red") {
      setMetaImage(metaRedImage);
      setInstaImage(instaRedImage);
    } else if (e.target.name === "teal") {
      setMetaImage(metaTealImage);
      setInstaImage(instaTealImage);
    } else {
      setMetaImage(metaNavyImage);
      setInstaImage(instaNavyImage);
    }
  }

  const fireFacebookPixel = () => {
    if (window.fbq) {
      window.fbq("track", "Lead");
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fireFacebookPixel();
  }, []);

  useEffect(() => {
    if (
      saved === true &&
      metaNavyImage !== undefined &&
      metaRedImage !== undefined &&
      metaTealImage !== undefined &&
      instaNavyImage !== undefined &&
      instaRedImage !== undefined &&
      instaTealImage !== undefined
    ) {
      setMetaImage(metaNavyImage);
      setInstaImage(instaNavyImage);
      save();
    }
  }, [
    saved,
    metaNavyImage,
    metaRedImage,
    metaTealImage,
    instaNavyImage,
    instaTealImage,
    instaRedImage,
  ]);

  async function save() {
    const finishUp = async (image, uuid) => {
      const response = await fetch(config.UPLOAD_URL, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uuid,
          fileType: "image/png",
        }),
      });

      const data = await response.json();
      const url = await uploadToSignedUrl(image, "image/png", data.result.url);
      return url;
    };

    finishUp(metaRedImage, uuid + "_red");
    finishUp(metaTealImage, uuid + "_teal");
    finishUp(metaNavyImage, uuid + "_navy");
    finishUp(instaRedImage, uuid + "_red_insta");
    finishUp(instaTealImage, uuid + "_teal_insta");
    finishUp(instaNavyImage, uuid + "_navy_insta");
  }

  const redirectUrl = "https://t2tmathpledge.teacher2teacher.education";

  const shareCopy =
    "Whether we teach math or not, the way we talk about math matters. Let’s show every student we believe in their potential! Take the pledge:";
  const sourceCode = "math_2024";

  async function facebookShare() {
    const url =
      redirectUrl +
      (uuid ? `?shareID=${uuid}_${currentTheme}&` : "?") +
      `code=${sourceCode}&utm_medium=fb_share&utm_campaign=math_2024&utm_source=facebook`;
    window.FB.ui({
      method: "share",
      href: url,
    });
  }

  return (
    <div className="body-container">
      <SectionHeader
        className={"blue-hdr"}
        sectionLabel={
          "Thanks for pledging to support every student's math potential!"
        }
      />
      <p>Looking to take another step with your school community toward building a math-positive school culture? Consider leading a session at your next staff or department meeting all about working as a group to shape students’ positive math identities. <a href="https://signforgood.s3.amazonaws.com/t2t_upload/Math+Pledge+Toolkit+-+A+Facilitation+Guide+For+Teacher+Conversations.pdf" target="_blank" rel="noopener noreferrer" className="facilitation-guide-link">You can access everything you’d need for a session in our facilitation guide – check it out by clicking here!</a></p>
      <p>And – choose a background color below to share your custom graphic:</p>
      <ul className="color-picker">
        <li>
          <button name="navy" onClick={updateTheme} id="navyBtn"></button>
          <label htmlFor="navyBtn">Navy</label>
        </li>
        <li>
          <button name="red" onClick={updateTheme} id="redBtn"></button>
          <label htmlFor="redBtn">Red</label>
        </li>
        <li>
          <button name="teal" onClick={updateTheme} id="tealBtn"></button>
          <label htmlFor="tealBtn">Teal</label>
        </li>
      </ul>
      {metaImage && (
        <img
          id="canvas-container"
          alt={selectedQuote.replace("your name here", name)}
          src={metaImage}
        ></img>
      )}
      <SectionHeader
        className={"blue-hdr"}
        sectionLabel={
          "Spread the word by sharing your pledge! Download the image and share on social media."
        }
      />
      <ul className="share-options">
        <li>
          <img onClick={facebookShare} alt="Share on Facebook" src={btnFB} />
        </li>
        {metaImage && (
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                `${redirectUrl}${
                  uuid ? `?shareID=${uuid}_${currentTheme}&` : "?"
                }code=${sourceCode}&utm_medium=tw_share&utm_campaign=math_2024&utm_source=twitter`
              )}&text=${encodeURIComponent(shareCopy)}`}
            >
              <img alt="Share on Twitter" src={btnTW}></img>
            </a>
          </li>
        )}
        {instaImage && (
          <li>
            <a
              id="IGS-ready"
              target="_blank"
              href={instaImage}
              download="t2t-math-pledge-IGS.png"
              rel="noopener noreferrer"
            >
              <img alt="Download to share on Instagram" src={btnIGS} />
            </a>
          </li>
        )}
        {metaImage && (
          <li>
            <a
              target="_blank"
              href={metaImage}
              download="t2t-math-pledge.png"
              rel="noopener noreferrer"
            >
              <button className="active-btn-red">Download your graphic</button>
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Output;
